<div class="margin-top-10">
    <div class="row text-center">
        <h1>{{content.RenderData.ContentEntryDescriptor.Information.Title}}</h1>
    </div>
    <div *ngIf="content.RenderData.VendorVideoID" class="padding-left-20 embedded-video">
        <div [innerHtml]="theUrl"></div>
    </div>
    <br />
    <app-social-media></app-social-media>
    <br />
    <div class="row"><p></div>
    <app-see-also *ngIf="content && content.SeeAlso && content.SeeAlso.length > 0" [displayAmount]="3" [concepts]="content.SeeAlso"></app-see-also>

    <div *ngIf="!textPart1" class="col-lg-12 col-md-12 col-sm-12">
        <span [innerHTML]="content.RenderData.Html | safeHtml"></span>                   
    </div>
    <div *ngIf="textPart1" class="col-lg-12 col-md-12 col-sm-12">
        <span [innerHTML]="textPart1 | safeHtml"></span>                   
    </div>
    <div *ngIf="textPart1" class="col-lg-12 col-md-12 col-sm-12">
        <app-header-ad [position]="'middle'"></app-header-ad>
    </div>
    <div *ngIf="textPart1" class="col-lg-12 col-md-12 col-sm-12">
        <span [innerHTML]="textPart2 | safeHtml"></span>                   
    </div>

    <div class="col-lg-12 col-md-12 col-sm-12">
        <app-see-also *ngIf="content && content.SeeAlso && content.SeeAlso.length > 3" [displayAmount]="100" [concepts]="content.SeeAlso"></app-see-also>
    </div>
</div>